// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"42":"53af02c9","260":"672d030c","470":"a6982869","920":"1213d167","967":"9cc893ba"}[chunkId] + ".js";
};